module.exports = __webpack_public_path__ + "static/media/linkedin.0a02fac0.svg";